import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Donationheader from '../components/Servicelist6/Donationheader'
import Donationdetails from '../components/Servicelist6/Donationdetails'


const Donationpage = () => {
  return (
    <div>
    <Navbar/>

    <Donationheader/>
    <Donationdetails/>
  


    <Footer/>

    </div>
  )
}

export default Donationpage